// noinspection DuplicatedCode

import {createGrid} from "../../../helpers/grids/grids";
import createElement from "../../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../../helpers/grids/helpers";
import {getSingleInputByNameV3} from "../../../helpers/forms/formInputsHelpers";

/**
 * Shared by cast and crew index views
 */
function initProductionCastIndex() {
	const typeSelect = document.querySelector('.type-select');
	const roleSelect = document.querySelector('.role-select');

	// noinspection JSValidateTypes
	/** @var {AuditionsDefs.AuditionViewType} */
	const viewType = getSingleInputByNameV3(document.body, 'audition_view_type');

	let paginationPageSize = 20;
	let cacheBlockSize = 100;

	// Use column auto height by default
	let getRowHeightHandler = undefined;

	if (viewType === 'cast-headshots') {
		paginationPageSize = 500;
		cacheBlockSize = 100;

		getRowHeightHandler = () => {
			return 180;
		}
	}


	const grid = createGrid('.cast-crew-grid', {
			columnDefs: getColumnDefinitions(),
			paginationPageSize,
			cacheBlockSize,

			_rowName: 'Requests',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				// Default behavior for all index views
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.view_url;
			}),
			getRowHeight: getRowHeightHandler,
		},
		window['routes/admin.productions.cast-crew.grid'],
		() => {
			return {
				type: typeSelect ? typeSelect.value : undefined,
				role: roleSelect ? roleSelect.value : undefined,
			}
		}
	);

	if (typeSelect) {
		typeSelect.addEventListener('change', () => {
			grid._refresh();
		})
	}
	if (roleSelect) {
		roleSelect.addEventListener('change', () => {
			grid._refresh();
		})
	}


	/** Methods */

	function removeRequest(request) {
		swalConfirm({
			title: 'Are you sure you want to delete this request?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(request.remove_url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})
	}

	/**
	 * We put this in a separate function so we can easily define empty
	 * columns and then remove them before giving them to ag grid
	 *
	 * @return {import('ag-grid-community/dist/lib/entities/colDef').ColDef[]}
	 */
	function getColumnDefinitions() {
		// Default handling for auditions views
		const columns = [
			{
				field: "full_name",
				headerName: 'Name',
				sortable: true,
				pinned: 'left',
				cellRenderer: createCellRenderer(params => {
					/** @var {Object<string,any>} */
					const request = params.data;
					if (viewType === 'all') {
						// noinspection JSUnresolvedReference
						if (request.audition_type === 'cast') {
							return createElement(`
								<div style="line-height: 1">
									<div>
										${params.data.full_name}
									</div>
									<div class="small text-muted text-wrap py-1" title="Audition Type">${request.crew_type_string}</div>
									<div class="small text-muted text-wrap pb-1" title="Roles">${request.roles_string}</div>
								</div>
							`);
						} else {
							return createElement(`
								<div style="line-height: 1">
									<div>
										${params.data.full_name}
									</div>
									<div class="small text-muted text-wrap py-1" title="Audition Type">${request.crew_type_string}</div>
								</div>
							`);
						}
					} else if (viewType === 'cast' || viewType === 'virtual-cast') {
						// noinspection JSUnresolvedReference
						return createElement(`
							<div style="line-height: 1">
								<div>
									${params.data.full_name}
								</div>
								<div class="small text-muted text-wrap py-1" title="Requested Roles">${params.data.roles_string}</div>
							</div>
						`);
					} else {
						// noinspection JSUnresolvedReference
						return params.data.full_name;
					}
				}),
				minWidth: 200,
				maxWidth: 210,
				suppressAutoSize: true,
				autoHeight: true,
				sort: 'asc',
			},
			{
				field: "email",
				headerName: 'Email',
				sortable: true,
			},
			viewType === 'crew' ?
				{
					field: "crew_type_string",
					headerName: "Type",
					sortable: false,
				} : undefined,
			{
				field: "public_id",
				headerName: '',
				maxWidth: 270,
				cellRenderer: createCellRenderer(params => {
					// noinspection JSUnresolvedVariable
					const buttons = createElement(`
                            <div class="buttons">
                            	<a class="btn btn-primary btn-sm ${!params.data.can_view ? 'd-none' : ''}" href="${params.data.view_url}">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    View
								</a>
								<a class="btn btn-info btn-sm ${!params.data.can_edit ? 'd-none' : ''}" href="${params.data.edit_url}">
                                    <i class="fa-solid fa-pen"></i>
                                    Edit
								</a>
                                <button type="button" class="btn btn-danger btn-sm ${!params.data.can_delete ? 'd-none' : ''} remove-audition-request-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Delete
                                </button>
                            </div>`
					)

					const deleteButton = buttons.querySelector('.remove-audition-request-button');

					deleteButton.onclick =
						() => removeRequest(params.data);

					return buttons;
				})
			},
		];

		// Filter non defined columns
		return columns.filter(column => column);
	}
}

export {
	initProductionCastIndex
}
